export enum ViewUI {
  // Left description panel, visible on desktop mode
  Column = 'column',

  // Left description panel, visible on desktop mode
  ColumnToggle = 'column-toggle',
    
  // Bottom description panel, visible at 960 below
  Drawer = 'drawer',

  // Floating title in top left
  TitleOnly = 'title-only',
  
  // tool bar button in menu
  Tools = 'tools',

  // Interaction tools, visible in drawer when responsive, floating on the scene in desktop
  Toolbar = 'toolbar',
  
  // Camera controls - zoom, pan, reset
  Camera = 'camera',
  
  // Play, pause, scrubber
  Media = 'media',

  // Free floating play, pause, scrubber, audio controls
  Mediabar = 'mediabar',

  // reset button
  Reset = 'reset',

  // audio controls
  Audio = 'audio',
  
  // White menu button and child items, visible at 960 below
  Menu = 'menu',
  
  // Pagination bar, visible when drawer is swiped up and other places
  Pagination = 'pagination',

  // fullscreen button
  Fullscreen = 'fullscreen',

  // help button
  Help = 'help',

  // content description
  Description = 'description',

  // wikipedia descriptions
  NodeInfo = 'nodeInfo',

  // search (anatomy tree) button
  Search = 'search',

  // presenter button
  Presenter = 'presenter',
  
  // BioDigital logo
  Logo = 'logo',

  // List of labels in column
  LabelList = 'labelList',

  // List of chapters in column
  ChapterList = 'chapterList',

  // anatomy node context label
  AnatomyLabels = 'anatomyLabels',

  // regular labels
  Labels = 'labels',

  // getting started tour
  Tutorial = 'tutorial',

  // Internet explorer warning
  InternetExplorerWarning = 'internetExplorerWarning',

  // Layout
  Layout = 'layout',

  // Content legend
  Legend = 'legend',

  // Loader
  Loader = 'loader',

  // 2D Annotate
  Undo = 'undo',

  // 2D Annotate
  Whiteboard = 'whiteboard',

  // Layers
  VisibilityLayers = 'visibilityLayers',

  // Context Actions
  ContextActions = 'contextActions',

  ToggleLabels = 'toggleLabels'
}
